import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Affordablecorporatecabserviceindelhi() {



  const cardData =
  {
    keyword: 'Affordable Corporate Cab Services in Delhi',
    heading: 'Aaryan Travels: Affordable Corporate Cab Services in Delhi',
    headingDescription: ' Aaryan Travels offers Affordable Corporate Cab Services in Delhi for startups, SMEs, and large enterprises seeking cost-effective yet professional transportation solutions. Whether you need daily employee pick-and-drop, executive transfers, airport pickups from IGI Airport, or intercity travel to Gurgaon, Noida, or Jaipur, our fleet of sedans, SUVs, and tempo travellers ensures comfort at competitive prices. With trained chauffeurs, transparent billing, monthly rental plans, and 24/7 availability, we deliver budget-friendly corporate mobility without compromising on quality or punctuality. From Connaught Place to Okhla, Rajouri Garden to Cyber City, Aaryan Travels is the trusted name for affordable corporate cab services across Delhi NCR.',

    top: 'Top Places to Visit in Delhi with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Red Fort (Lal Qila)",
    "description": "Built in 1648 by Mughal Emperor Shah Jahan, the Red Fort is a UNESCO World Heritage Site known for its massive red sandstone walls and grand architecture. Inside, it houses royal chambers, museums, and gardens that reflect Mughal opulence. The evening sound-and-light show brings history to life. Every Independence Day, the Prime Minister addresses the nation from here. Red Fort is Delhi’s towering emblem of history and pride."
  },
  {
    "title": "India Gate",
    "description": "India Gate is a majestic war memorial dedicated to Indian soldiers who lost their lives during World War I. The flame of Amar Jawan Jyoti burns eternally in their honor. Surrounded by lush lawns, it is a popular evening hangout spot for families and tourists. Illuminated beautifully at night, it creates a captivating view. India Gate is Delhi’s patriotic landmark of remembrance."
  },
  {
    "title": "Qutub Minar",
    "description": "Standing at 73 meters, Qutub Minar is the world’s tallest brick minaret and a UNESCO World Heritage Site. Built in 1193, it features stunning Quranic inscriptions and sandstone carvings. The surrounding Qutub Complex includes the Iron Pillar and ancient mosques. Visitors admire its architectural brilliance and historical significance. Qutub Minar is Delhi’s towering masterpiece of ancient engineering."
  },
  {
    "title": "Lotus Temple",
    "description": "Shaped like a blooming lotus, the Lotus Temple is a Bahá’í House of Worship open to people of all faiths. Its 27 white marble petals and reflective pools create an atmosphere of serenity. No religious rituals are performed here—only silent meditation. Surrounded by green lawns, it is a peaceful escape from city chaos. Lotus Temple is Delhi’s symbol of spiritual unity."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb, built in 1570, is an exquisite Mughal mausoleum and a precursor to the Taj Mahal. Set in Persian-style gardens with water channels, it features red sandstone and white marble architecture. The symmetry and artistry leave visitors in awe. Birds and greenery add to its charm. Humayun’s Tomb is Delhi’s elegant monument of love and legacy."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a grand cultural complex known for its intricate carvings, exhibitions, and musical fountain shows. Built using pink sandstone without steel, it showcases 20,000 statues and traditional craftsmanship. The boat ride inside narrates India’s ancient innovations. Evening lights make it even more beautiful. Akshardham is Delhi’s majestic tribute to art, spirituality, and culture."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid is one of India’s largest mosques, built by Shah Jahan in 1656. Its grand courtyard can accommodate over 25,000 worshippers. The twin minarets and domes are classic examples of Mughal architecture. Visitors can climb the minaret for stunning views of Old Delhi. Nearby food streets offer kebabs and biryani. Jama Masjid is Delhi’s timeless blend of faith and flavor."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is a black marble platform marking the cremation site of Mahatma Gandhi. Surrounded by lush gardens and eternal flames, it radiates peace and reverence. Inspirational quotes from Gandhi are inscribed around the memorial. World leaders often visit to pay homage. Raj Ghat is Delhi’s serene tribute to the Father of the Nation."
  },
  {
    "title": "Hauz Khas Village",
    "description": "Hauz Khas Village is a trendy fusion of history and modern lifestyle. It houses medieval ruins, a lake, art boutiques, cafes, and nightlife spots. Tourists explore the Hauz Khas Fort by day and relax at vibrant rooftop lounges by night. It offers a picturesque blend of culture and entertainment. Hauz Khas is Delhi’s youthful urban hotspot."
  },
  {
    "title": "Chandni Chowk & Paranthe Wali Gali",
    "description": "Chandni Chowk is one of Delhi’s oldest markets, buzzing with spice shops, jewelry stores, and silk vendors. Paranthe Wali Gali is famous for its stuffed parathas served with pickles and chutneys. Narrow lanes filled with rickshaws and street vendors offer a true taste of Old Delhi. The aroma of jalebi and chaat fills the air. Chandni Chowk is Delhi’s chaotic yet flavorful cultural maze."
  }
],


 "services": [
  {
    "name": "Affordable Corporate Cab Services in Delhi",
    "description": "Our Affordable Corporate Cab Services in Delhi are designed to provide businesses with cost-effective and reliable transportation solutions. Ideal for startups, SMEs, and large enterprises alike, we offer a fleet of well-maintained vehicles driven by professional chauffeurs committed to punctuality and safety. With customizable packages and transparent pricing, our services ensure your corporate travel needs are met without straining your budget, all while maintaining high standards of comfort and professionalism."
  },
  {
    "name": "Budget Corporate Taxi Delhi",
    "description": "Budget Corporate Taxi Delhi offers an economical option for businesses seeking dependable and efficient taxi services. Whether for daily employee commutes, client meetings, or airport transfers, our service delivers timely pickups with clean, comfortable vehicles driven by experienced drivers, ensuring a hassle-free experience that balances quality and affordability."
  },
  {
    "name": "Cost Effective Office Cab Delhi",
    "description": "Cost Effective Office Cab Delhi specializes in providing affordable transportation solutions tailored for office staff and daily commutes. Our well-organized routes and shift-based scheduling help companies manage employee travel efficiently while minimizing expenses. With safety protocols and GPS tracking in place, we guarantee reliable service that meets your operational needs."
  },
  {
    "name": "Corporate Car Hire Delhi",
    "description": "Corporate Car Hire Delhi provides flexible vehicle rental options with professional chauffeurs to meet the diverse requirements of businesses. From executive travel to staff transfers, our varied fleet including sedans and SUVs ensures comfortable, timely, and secure transportation, all backed by competitive pricing and customer-centric service."
  },
  {
    "name": "Employee Transport Delhi",
    "description": "Employee Transport Delhi delivers safe and dependable daily transportation for your workforce. Designed to improve attendance and reduce travel-related stress, our service features route optimization, verified drivers, and real-time tracking, ensuring employees arrive on time and in comfort. Our scalable solutions cater to small teams as well as large organizations."
  },
  {
    "name": "Corporate Cab Deals Delhi",
    "description": "Corporate Cab Deals Delhi offers specially curated packages that combine affordability with premium service standards. Whether you need regular monthly rentals or occasional business trips, our deals provide flexible options that help businesses reduce transportation costs without sacrificing quality or reliability."
  },
  {
    "name": "Low Cost Corporate Cab Delhi",
    "description": "Low Cost Corporate Cab Delhi focuses on delivering budget-friendly corporate taxi services across the city. Our clean vehicles and courteous drivers ensure timely and safe travel for business professionals, with easy booking and transparent billing, making us the preferred choice for companies aiming to optimize their transport expenses."
  },
  {
    "name": "Delhi Business Cab Services",
    "description": "Delhi Business Cab Services is dedicated to supporting corporate clients with reliable and professional taxi services. Whether it’s for meetings, airport transfers, or site visits, our fleet of well-maintained cars and trained drivers ensure comfort, punctuality, and seamless travel experiences tailored to business needs."
  },
  {
    "name": "Reliable Corporate Cab Delhi",
    "description": "Reliable Corporate Cab Delhi guarantees consistent and trustworthy transportation solutions for businesses. With a focus on safety, timely service, and customer satisfaction, our experienced chauffeurs and well-serviced vehicles help companies maintain smooth daily operations and stress-free corporate travel."
  },
  {
    "name": "Corporate Chauffeur Delhi",
    "description": "Corporate Chauffeur Delhi offers premium chauffeur-driven vehicles for executives and VIP clients. Our drivers are trained to provide discreet, courteous, and professional service, ensuring that your corporate journeys are productive and comfortable, whether for meetings, events, or client transfers."
  },
  {
    "name": "Office Cab Delhi",
    "description": "Office Cab Delhi provides efficient and affordable daily commute solutions for office employees. With shift-based scheduling, route optimization, and GPS-enabled tracking, our service enhances punctuality and reduces transportation-related challenges, fostering better workforce productivity."
  },
  {
    "name": "Staff Transport Cab Delhi",
    "description": "Staff Transport Cab Delhi is designed to cater to large teams requiring dependable and safe group transport. Whether for factories, corporate offices, or industrial areas, our mini-buses, vans, and MUVs operate on scheduled routes to ensure timely pickups and drop-offs, with full compliance to safety standards."
  },
  {
    "name": "Corporate Vehicle Rental Delhi",
    "description": "Corporate Vehicle Rental Delhi offers a broad range of vehicles for rent with professional drivers to meet the dynamic needs of businesses. Flexible rental terms, combined with well-maintained cars and SUVs, allow companies to choose the perfect transportation solution for short-term projects or long-term assignments."
  },
  {
    "name": "Corporate Cab Packages Delhi",
    "description": "Corporate Cab Packages Delhi provides tailored transportation plans that combine affordability with premium service levels. From daily employee commutes to executive travel, our packages offer fixed pricing, priority support, and scalable vehicle options, simplifying corporate mobility management for your business."
  },
  {
    "name": "Best Corporate Cab Delhi",
    "description": "Best Corporate Cab Delhi is recognized for delivering top-quality and dependable transportation solutions for businesses across the capital. Our commitment to safety, punctuality, and customer service makes us the trusted choice for corporate clients seeking excellence in every ride."
  }
],
"tableData": [
  ["Affordable Corporate Cab Services in Delhi", "Budget Corporate Taxi Delhi"],
  ["Cost Effective Office Cab Delhi", "Corporate Car Hire Delhi"],
  ["Employee Transport Delhi", "Corporate Cab Deals Delhi"],
  ["Low Cost Corporate Cab Delhi", "Delhi Business Cab Services"],
  ["Reliable Corporate Cab Delhi", "Corporate Chauffeur Delhi"],
  ["Office Cab Delhi", "Staff Transport Cab Delhi"],
  ["Corporate Vehicle Rental Delhi", "Corporate Cab Packages Delhi"],
  ["Best Corporate Cab Delhi", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Affordable Corporate Cab Services in Delhi",
    "WhyChoosedescription": "Aaryan Travels offers cost-effective and reliable corporate cab services tailored to businesses in Delhi."
  },
  {
    "WhyChooseheading": "Timely Pickup and Drop for Smooth Commutes",
    "WhyChoosedescription": "Ensure punctual transportation for your employees and clients without compromising on comfort."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Business Travel",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained to provide a professional and comfortable experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Delhi’s Corporate Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with the city’s traffic patterns and routes for efficient travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront and competitive pricing, including GST-compliant invoices, with no surprises."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Corporate Clients",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, cancellations, and inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans Tailored to Your Business Needs",
    "WhyChoosedescription": "Choose from daily, weekly, or monthly cab hire contracts customized to fit your organization’s budget."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Corporate Travel",
    "WhyChoosedescription": "Select from sedans, SUVs, and tempo travellers based on your team size and travel preferences."
  }
]






























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer affordable corporate cab services in Delhi?',
    answer: 'Yes, Aaryan Travels provides cost-effective and reliable corporate cab services throughout Delhi to meet your business travel needs.',
  },
  {
    question: 'How can I book affordable corporate cab services in Delhi with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for affordable corporate cab services in Delhi?',
    answer: 'Aaryan Travels offers a wide range of vehicles including sedans, SUVs, and economy cars suitable for corporate travel.',
  },
  {
    question: 'Are affordable corporate cab services suitable for daily employee commute in Delhi?',
    answer: 'Yes, we provide customized and affordable corporate cab solutions for daily employee pickups and drops across Delhi.',
  },
  {
    question: 'Are drivers experienced and trained for corporate travel requirements in Delhi?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and familiar with corporate travel standards in Delhi.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group affordable corporate cab bookings in Delhi?',
    answer: 'Yes, we manage group transportation and bulk bookings for corporate meetings, events, and conferences efficiently.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for affordable corporate cab services in Delhi?',
    answer: 'Yes, flexible billing options including monthly invoicing are available for our corporate clients.',
  },
  {
    question: 'Is affordable corporate cab service available 24x7 in Delhi?',
    answer: 'Yes, Aaryan Travels offers round-the-clock affordable corporate cab services in Delhi to ensure seamless business travel.',
  },
  {
    question: 'What safety measures are in place for affordable corporate cab services in Delhi?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety protocols to ensure passenger safety.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for affordable corporate cab bookings in Delhi?',
    answer: 'Yes, full customization of pickup and drop points is available based on your corporate travel needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Sharma',
    feedback: 'Aaryan Travels provides affordable corporate cab services in Delhi with great reliability and professionalism.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aarti Singh',
    feedback: 'Excellent service and value for money. Affordable corporate cabs by Aaryan Travels in Delhi are highly recommended.',
    rating: 5,
  },
];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Affordable Corporate Cab Services in Delhi",
  "image": "https://aaryantravels.com/assets/images/affordable-corporate-cab-delhi.jpg", // replace with actual image URL
  "description": "Aaryan Travels offers affordable corporate cab services in Delhi, providing budget-friendly business taxis, employee transport solutions, and reliable corporate chauffeur services.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7", // example rating
    "ratingCount": "3200", // example rating count
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200", // example price
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/affordable-corporate-cab-services-delhi"
  }
};







  return (
    <div>

<Helmet>
  <title>Affordable Corporate Cab Services in Delhi | Budget Business Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Get affordable corporate cab services in Delhi with Aaryan Travels. Budget-friendly office cabs, corporate chauffeur services, and employee transport at great prices."
  />
  <meta
    name="keywords"
    content="Affordable Corporate Cab Services in Delhi, Budget Corporate Taxi Delhi, Cost Effective Office Cab Delhi, Corporate Car Hire Delhi, Employee Transport Delhi, Corporate Cab Deals Delhi, Low Cost Corporate Cab Delhi, Delhi Business Cab Services, Reliable Corporate Cab Delhi, Corporate Chauffeur Delhi, Office Cab Delhi, Staff Transport Cab Delhi, Corporate Vehicle Rental Delhi, Corporate Cab Packages Delhi, Best Corporate Cab Delhi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Affordablecorporatecabserviceindelhi;